import type { StyleLayer } from './utils/types'

export const layers_parkingLars_parkinglines_labels: StyleLayer[] = [
  {
    id: 'parking labels',
    type: 'symbol',
    minzoom: 15,
    layout: {
      'text-allow-overlap': true,
      'text-field': ['to-string', ['get', 'capacity']],
      'text-font': ['Open Sans Regular', 'Arial Unicode MS Regular'],
      'text-ignore-placement': true,
      'text-rotate': [
        'case',
        ['>', ['get', 'angle'], 90],
        ['-', ['get', 'angle'], 180],
        ['get', 'angle'],
      ],
      'text-size': ['interpolate', ['linear'], ['zoom'], 14.99, 0, 15, 9, 20, 20],
    },
    paint: {
      'icon-opacity': ['interpolate', ['linear'], ['zoom'], 0, 0, 14, 0, 15, 1],
      'text-color': [
        'match',
        ['get', 'operator_type'],
        ['private'],
        'rgba(61, 61, 61, 0.5)',
        'rgb(60, 60, 60)',
      ],
      'text-halo-color': 'rgb(255, 255, 255)',
      'text-halo-width': ['interpolate', ['linear'], ['zoom'], 15, 1, 18, 2.5],
    },
  },
]
